'use client';

import dynamic from 'next/dynamic';
import React from 'react';

import { cn } from '../helpers/cn';

import animation from './animationProgressBar.json';

// @lottiefiles/react-lottie-player touches `document` at import time, which crashes SSR (client
// components are still server-rendered for the initial HTML). Load it client-only so it never runs
// on the server.
const Player = dynamic(() => import('@lottiefiles/react-lottie-player').then((mod) => mod.Player), {
    ssr: false
});

export type ProgressBarAnimationProps = {
    className?: string;
    classNamePlayer?: string;
};

function ProgressBarAnimation(props: ProgressBarAnimationProps): React.JSX.Element {
    const { className, classNamePlayer } = props;
    return (
        <div className={cn(className || 'py-38', ' ')}>
            <Player
                autoplay
                loop
                src={animation}
                className={`${classNamePlayer}`}
            />
        </div>
    );
}

export default ProgressBarAnimation;
